import { WINDOW } from "../utils/window-utils"
import Utils from "../utils/utilities"
import { getSingletonInstance } from "../services/singleton-cache"

export default function OnEvent(args: any): Function {
    return (target: any, propertyKey: string) => {
        if (args && Utils.isDefined(args.selector)) {
            Utils.asArray(Utils.isDefined(args.root) ? args.root.querySelectorAll(args.selector) : WINDOW.nativeWindow.document.querySelectorAll(args.selector)).forEach(element => {
                const eventNames: Array<any> = args.eventNames || ['click']
                eventNames.forEach(eventName => element.addEventListener(eventName, $event => {
                    const singletonTarget: any = getSingletonInstance(target)
                    singletonTarget[propertyKey].bind(singletonTarget)($event)
                }))
            })
        }
    }
}